import { atom } from 'recoil';

export const showButtonsStateAtom = atom({
  key: 'showButtonsState',
  default: null,
});
